/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CalculationResultStatusDetailErrorLevel {
    Warning = 'Warning',
    Error = 'Error'
  }

    export const CalculationResultStatusDetailErrorLevelTranslocoMap: Record<CalculationResultStatusDetailErrorLevel, string> = {
    [CalculationResultStatusDetailErrorLevel.Warning]: 'calculationResultStatusDetailErrorLevel.warning',
    [CalculationResultStatusDetailErrorLevel.Error]: 'calculationResultStatusDetailErrorLevel.error',
    };

    export const CalculationResultStatusDetailErrorLevelOptions = [
  { value: CalculationResultStatusDetailErrorLevel.Warning, labelKey: 'calculationResultStatusDetailErrorLevel.warning' },
  { value: CalculationResultStatusDetailErrorLevel.Error, labelKey: 'calculationResultStatusDetailErrorLevel.error' },
    ];

